import Api from "utils/api/Api"

export const getReadingTest = (type)=>{
    return Api.get(`/api/reading/test/new/${type}`);
}

export const getMyTest = ()=>Api.get('/api/reading/test/my');